import { post } from '@/utils/request'

// 获取店铺列表
export function shopList(data) {
  return post('/admin/edu_youth_shop/shopList', data)
}

// 获取店铺详情
export function shopDetail(data) {
  return post('/admin/edu_youth_order/shopDetail', data)
}

// 店铺审核同意
export function shopApprove(data) {
  return post('/admin/edu_youth_order/shopApprove', data)
}

// 店铺审核拒绝
export function shopReject(data) {
  return post('/admin/edu_youth_shop/shopReject', data)
}

// 获取店铺详情（新接口）
export function detailMerchant(data) {
  return post('/admin/merchant/detailMerchant', data)
}

// 设置店铺轮播图
export function setBanners(data) {
  return post('/admin/merchant/setBanners', data)
}

// 获取设置列表
export function settingsList(data) {
  return post('/admin/edu_youth_shop/settingsList', data)
}

// 保存设置
export function settingsUpdate(data) {
  return post('/admin/edu_youth_shop/settingsUpdate', data)
}
